import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';
import ChartDataLabels from 'chartjs-plugin-datalabels';

ChartJS.register(ArcElement, Tooltip, Legend,ChartDataLabels);

export default function DoughnutChart({ data, legend, ...props }) {
  return <Doughnut options={{ plugins: {
    legend: {
      display: !legend ? false : true,
      labels: {
        font: {
          size: 14
        }
      },
    },
    tooltip: {
      callbacks: {
        label: (context) => {
          return context.formattedValue + '%'
        }
      }
    },
    datalabels :{
      display: false
    }
  }, }} data={data} { ...props } />;
}
